import script from "./EditSwift.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSwift.vue?vue&type=script&setup=true&lang=js"

import "./EditSwift.vue?vue&type=style&index=0&id=4c7be0ed&scoped=true&lang=css"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7be0ed"]])

export default __exports__